import Lottie from "lottie-react";
import { useEffect, useRef, useState } from "react";
import { FaArrowDownLong } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { Link } from "react-scroll";
import "./services.css";

const Services = ({ servicesData }) => {
  const [activeSection, setActiveSection] = useState(-1);
  const containerRef = useRef(null);
  const navigate = useNavigate();

  // Default animations in case API data doesn't provide them
  const defaultAnimations = [ 
    require("../../Images/First.json"),
    require("../../Images/Chatbot.json"),
    require("../../Images/Second.json"),
  ];

  // Create service items from API data or use defaults
  const serviceItems = servicesData?.map((service, index) => ({
    title: service?.title || "Service Title",
    text: service?.text || "Service description goes here",
    animation: defaultAnimations[index] || defaultAnimations[0],
    buttonName: service?.button_name || "Explore",
    buttonUrl: service?.button_url || "/our-products",
  })) || [
      {
        title: "Customized Aggregated Investment Ecosystem",
        text: "Experience a world-class trading environment specially curated just for you...",
        animation: defaultAnimations[0],
        buttonName: "Explore",
        buttonUrl: "/our-products",
      },
      {
        title: "SumBoT3.0 – AI Enabled Financial Research- Simplified",
        text: "Unlock the power of Al with SumBot3.0, your personal financial research assistant...",
        animation: defaultAnimations[1],
        buttonName: "Explore",
        buttonUrl: "/our-products",
      },
      {
        title: "Automated Investing and Copy Trading",
        text: "Gain Access to some of the most renowned Investment Dealers...",
        animation: defaultAnimations[2],
        buttonName: "Explore",
        buttonUrl: "/our-products",
      },
    ];

  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current) return;

      const container = containerRef.current;
      const containerTop = container.getBoundingClientRect().top;
      const containerHeight = container.getBoundingClientRect().height;
      const sectionHeight = containerHeight / 6;

      const scrollPosition = window.scrollY - (containerTop + window.scrollY);

      if (scrollPosition < 0) {
        setActiveSection(0);
      } else if (scrollPosition < sectionHeight) {
        setActiveSection(0);
      } else if (scrollPosition < 3 * sectionHeight) {
        setActiveSection(1);
      } else {
        setActiveSection(2);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div className="service-container" ref={containerRef}>
      <div className="service-container-sticky">
        {serviceItems.map((item, index) => (
          <div
            key={index}
            className={`sticky-section ${index === activeSection ? "active" : ""
              } ${index < activeSection ? "past" : ""}`}
          >
            {index === 2 && (
              <Link
                activeClass="active"
                to={"homeAboutPC"}
                spy={true}
                smooth={true}
                offset={-70}
                duration={500}
              >
                <button className="homeDownBtn">
                  <p>
                    <FaArrowDownLong className="fw-bold" />
                  </p>
                </button>
              </Link>
            )}
            <div>
              <p
                className={`${index === activeSection ? "mfs-5" : "mfs-4"} fwr`}
              >
                {item.title}
              </p>
              <p
                className={`service-description ${index === activeSection ? "active mfs-2" : "mfs-1"
                  } fwt`}
              >
                {item.text}
              </p>
              <button
                className="sumBtn mfs-4 rounded-5 mt-3"
                onClick={() => { window.location.href = item.buttonUrl }}
              >
                {item.buttonName}
              </button>

              <div
                className={`serviceImageBox ${index === activeSection ? "active" : ""
                  }`}
              >
                <Lottie
                  animationData={item.animation}
                  loop={true}
                  style={{ height: "100%", width: "100%" }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Services;
